var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c("div", { staticClass: "box" }, [
      _c("h1", { staticClass: "title is-4" }, [_vm._v("Filtros de busqueda")]),
      _vm._v(" "),
      _vm.$store.getters.hasAnyRole(["empleador"])
        ? _c(
            "div",
            { staticClass: "field" },
            [
              _c("label", { staticClass: "label" }, [
                _vm._v("\n        Mis recibos\n        "),
                _c(
                  "span",
                  { staticClass: "is-pulled-right" },
                  [
                    _c(
                      "b-tooltip",
                      {
                        attrs: {
                          label: "Opción para empleador",
                          position: "is-left",
                        },
                      },
                      [_c("i", { staticClass: "far fa-star is-pulled-right" })]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "b-checkbox",
                {
                  attrs: { disabled: _vm.selectedUser != null },
                  model: {
                    value: _vm.soloMisRecibos,
                    callback: function ($$v) {
                      _vm.soloMisRecibos = $$v
                    },
                    expression: "soloMisRecibos",
                  },
                },
                [_vm._v("Ver solo mis recibos")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.soloMisRecibos,
              expression: "!soloMisRecibos",
            },
          ],
        },
        [
          this.hasRole([_vm.constants.STRINGS.ROLES.LYRIS.ID])
            ? _c(
                "div",
                { staticClass: "field mb-0" },
                [
                  _c(
                    "div",
                    { staticClass: "field" },
                    [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("\n            Por organización\n            "),
                        _c(
                          "span",
                          { staticClass: "is-pulled-right" },
                          [
                            _c(
                              "b-tooltip",
                              {
                                attrs: {
                                  label: "Opción para Lyris",
                                  position: "is-left",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-star is-pulled-right",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.selectedOrganization
                        ? _c(
                            "b-autocomplete",
                            {
                              staticClass: "input-field",
                              attrs: {
                                data: _vm.searchOrganizationResults,
                                loading: _vm.isFetching,
                                placeholder: "Escriba nombre o id",
                                field: "razon_social",
                              },
                              on: {
                                input: function ($event) {
                                  return _vm.getOrganizationsWithInstalledModule(
                                    _vm.constants.STRINGS.MODULES.RECIBOS.ID
                                  )
                                },
                                select: (option) =>
                                  _vm.selectOrganization(option),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c("i", {
                                          staticClass: "fas fa-building",
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(props.option.id) +
                                            " - " +
                                            _vm._s(
                                              props.option.razon_social.toUpperCase()
                                            ) +
                                            "\n              "
                                        ),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "is-size-7" },
                                          [
                                            _vm._v(
                                              _vm._s(props.option.slug) +
                                                " - " +
                                                _vm._s(props.option.cuit)
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1271691841
                              ),
                              model: {
                                value: _vm.organizationInput,
                                callback: function ($$v) {
                                  _vm.organizationInput = $$v
                                },
                                expression: "organizationInput",
                              },
                            },
                            [
                              _vm._v(" "),
                              _c("template", { slot: "empty" }, [
                                _vm._v(
                                  "No hay resultados para " +
                                    _vm._s(_vm.organizationInput)
                                ),
                              ]),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-field",
                    { staticClass: "mb-5" },
                    [
                      _vm.selectedOrganization
                        ? _c(
                            "b-tag",
                            {
                              attrs: {
                                icon: "fas fa-building",
                                size: "is-medium",
                                attached: "",
                                "aria-close-label": "Close tag",
                                closable: "",
                              },
                              on: {
                                close: function ($event) {
                                  return _vm.unselectOrganization()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.selectedOrganization.razon_social.toUpperCase()
                                  ) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.soloMisRecibos,
              expression: "!soloMisRecibos",
            },
          ],
        },
        [
          this.hasRole([
            _vm.constants.STRINGS.ROLES.LYRIS.ID,
            _vm.constants.STRINGS.ROLES.EMPLEADOR.ID,
          ])
            ? _c(
                "div",
                { staticClass: "field mb-0" },
                [
                  _c(
                    "div",
                    { staticClass: "field" },
                    [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("\n              Por empleado\n              "),
                        _c(
                          "span",
                          { staticClass: "is-pulled-right" },
                          [
                            _c(
                              "b-tooltip",
                              {
                                attrs: {
                                  label: "Opción para empleador",
                                  position: "is-left",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "far fa-star is-pulled-right",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.selectedUser
                        ? _c(
                            "b-autocomplete",
                            {
                              staticClass: "input-field",
                              attrs: {
                                data: _vm.searchUserResults,
                                loading: _vm.isFetching,
                                placeholder: "Escriba nombre o apellido",
                                field: "apellido",
                              },
                              on: {
                                input: _vm.getUser,
                                select: (option) => _vm.selectUser(option),
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c("i", { staticClass: "fas fa-user" }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              props.option.apellido.toUpperCase()
                                            ) +
                                            ", " +
                                            _vm._s(props.option.nombre) +
                                            "\n                "
                                        ),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "is-size-7" },
                                          [
                                            _vm._v(
                                              _vm._s(props.option.cuil) +
                                                " - " +
                                                _vm._s(props.option.email)
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1831849808
                              ),
                              model: {
                                value: _vm.userInput,
                                callback: function ($$v) {
                                  _vm.userInput = $$v
                                },
                                expression: "userInput",
                              },
                            },
                            [
                              _vm._v(" "),
                              _c("template", { slot: "empty" }, [
                                _vm._v(
                                  "No hay resultados para " +
                                    _vm._s(_vm.userInput)
                                ),
                              ]),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-field",
                    { staticClass: "mb-5" },
                    [
                      _vm.selectedUser
                        ? _c(
                            "b-tag",
                            {
                              attrs: {
                                icon: "fas fa-user",
                                size: "is-medium",
                                attached: "",
                                "aria-close-label": "Close tag",
                                closable: "",
                              },
                              on: {
                                close: function ($event) {
                                  return _vm.unselectUser()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.selectedUser.apellido.toUpperCase()
                                  ) +
                                  ", " +
                                  _vm._s(_vm.selectedUser.nombre) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "field is-horizontal is-mobile" }, [
        _c("div", { staticClass: "field-body" }, [
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.year,
                    expression: "year",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "min:4|max:4|min_value:1920|numeric",
                    expression: "'min:4|max:4|min_value:1920|numeric'",
                  },
                ],
                staticClass: "input has-text-centered",
                class: { "is-danger": _vm.errors.has("año") },
                attrs: { name: "año", placeholder: "Año" },
                domProps: { value: _vm.year },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.year = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.month,
                    expression: "month",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "max:2|min_value:1|max_value:12|numeric",
                    expression: "'max:2|min_value:1|max_value:12|numeric'",
                  },
                ],
                staticClass: "input has-text-centered",
                class: { "is-danger": _vm.errors.has("mes") },
                attrs: {
                  name: "mes",
                  disabled: _vm.year == "" || _vm.errors.has("año"),
                  placeholder: "Mes",
                },
                domProps: { value: _vm.month },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.month = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "control" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.day,
                    expression: "day",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "max:2|min_value:1|max_value:31|numeric",
                    expression: "'max:2|min_value:1|max_value:31|numeric'",
                  },
                ],
                staticClass: "input has-text-centered",
                class: { "is-danger": _vm.errors.has("dia") },
                attrs: {
                  name: "dia",
                  disabled: _vm.month == "" || _vm.errors.has("mes"),
                  placeholder: "Dia",
                },
                domProps: { value: _vm.day },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.day = $event.target.value
                  },
                },
              }),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.errors.has("año")
        ? _c("span", { staticClass: "help is-danger" }, [
            _vm._v(_vm._s(_vm.errors.first("año"))),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.errors.has("mes")
        ? _c("span", { staticClass: "help is-danger" }, [
            _vm._v(_vm._s(_vm.errors.first("mes"))),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.errors.has("dia")
        ? _c("span", { staticClass: "help is-danger" }, [
            _vm._v(_vm._s(_vm.errors.first("dia"))),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label", attrs: { for: "" } }, [
          _vm._v("Por tipo de recibo"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "control" }, [
          _vm.loadingTiposRecibos
            ? _c("input", {
                staticClass: "input",
                attrs: { type: "text", value: "- Cargando -" },
              })
            : _c("div", { staticClass: "select is-fullwidth" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.tipoRecibosSelected,
                        expression: "tipoRecibosSelected",
                      },
                    ],
                    attrs: { name: "" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.tipoRecibosSelected = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v("Todos los tipos"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.tiposRecibos, function (recibo, i) {
                      return _c(
                        "option",
                        { key: i, domProps: { value: recibo.id } },
                        [_vm._v(_vm._s(recibo.nombre))]
                      )
                    }),
                  ],
                  2
                ),
              ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", { staticClass: "label", attrs: { for: "" } }, [
          _vm._v("Por estado de recibo"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "control" }, [
          _c("div", { staticClass: "select is-fullwidth" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.estadoRecibos,
                    expression: "estadoRecibos",
                  },
                ],
                attrs: { name: "" },
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.estadoRecibos = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", { domProps: { value: null } }, [
                  _vm._v("Cualquier estado"),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "pendiente" } }, [
                  _vm._v("Pendiente"),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "conformidad" } }, [
                  _vm._v("En conformidad"),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "disconformidad" } }, [
                  _vm._v("En disconformidad"),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "buttons mt-4" }, [
        _c(
          "button",
          { staticClass: "button is-light", on: { click: _vm.setDefaults } },
          [_c("i", { staticClass: "fas fa-broom" }), _vm._v(" Limpiar filtros")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button is-primary",
            attrs: { disabled: _vm.errors.count() > 0 },
            on: { click: _vm.updateListado },
          },
          [_c("i", { staticClass: "fas fa-search" }), _vm._v(" Buscar")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [
        _vm._v("\n        Por fecha\n      "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "help" }, [
        _vm._v("El campo en blanco representa cualquier dia, mes o año"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }